import { colors, en_GB, fr_FR, ConfigProvider as UIKitConfigProvider } from '@honestica/ui-kit/src';
import { selectLocale } from '@store/user/user.selector';
import { useSelector } from 'react-redux';

export const UIKitProvider = ({ children }: { children: React.ReactNode }) => {
  const locale = useSelector(selectLocale);
  /**
   * We must do this to be compliant with date-fns
   * @See https://github.com/ant-design/ant-design/issues/26699
   * @See https://github.com/react-component/picker/pull/289/files
   */
  let currentLocale;
  if (locale === 'en') {
    currentLocale = en_GB;
    en_GB.DatePicker!.lang.locale = 'en_GB';
  } else {
    fr_FR.DatePicker!.lang.locale = 'fr';
    currentLocale = fr_FR;
  }

  return (
    <UIKitConfigProvider
      theme={{
        token: {
          fontFamily: 'Open Sans',

          colorPrimary: colors.blue[5],
          colorLink: colors.blue[7],
        },
        components: {
          Checkbox: {
            colorBorder: colors.grey[6],
          },
          Button: {
            primaryShadow: 'none',
          },
          Layout: {
            bodyBg: colors.grey[2],
          },
          Menu: {
            iconSize: 24,
            itemBg: 'transparent',
            subMenuItemBg: colors.grey[3],
          },
          Modal: {
            titleFontSize: 18,
          },
          Table: {
            colorBorderSecondary: colors.grey[4],
            rowHoverBg: colors.grey[3],
            rowSelectedBg: colors.orange[1],
            rowSelectedHoverBg: colors.orange[2],
          },
        },
      }}
      locale={currentLocale}
    >
      {children}
    </UIKitConfigProvider>
  );
};
